import {CBARObject3D, CBARObject3DProperties} from "./CBARObject3D";
import * as THREE from "three";
import {CBARMediaInfo} from "../internal";
import {CBARContext} from "../CBARContext";
import {hfovToVFov, vfovToHFov} from "../internal/Utils";

export interface CBARCameraProperties extends CBARObject3DProperties {
    fov:number
}

export class CBARCameraIntrinsics extends CBARObject3D<CBARCameraIntrinsics> {

    constructor(context:CBARContext) {
        super(context);
        this.camera = context.gl.camera;
        this.setRenderObject(this.camera)
    }

    public camera:THREE.PerspectiveCamera;
    public hFov:number = 40.0;

    load(basePath:string|undefined, json:CBARCameraProperties) : Promise<CBARCameraIntrinsics> {
        const promises:any[] = [super.load(basePath, json)];

        if (json.hasOwnProperty('fov')) {
            this.hFov = json.fov
        }

        return new Promise<CBARCameraIntrinsics>((resolve, reject) => {
            Promise.all(promises).then(()=>{

                resolve(this)
            }).catch(error=>{
                reject(error)
            })
        })
    }

    public data() : any {
        const data:any = super.data();

        data.fov = this.hFov;

        return data
    }

    private _media?:CBARMediaInfo;

    public setMediaProperties(props:CBARMediaInfo) {
        this._media = props;
        if (this._media) {

            this.camera.aspect = this._media.width / this._media.height;
            this.camera.fov = hfovToVFov(this.hFov, this.camera.aspect);
            this.camera.updateProjectionMatrix();

            //console.log("Projection Matrix", this.camera.projectionMatrix);
            //console.log(`Camera aspect ratio: ${this.camera.aspect},  h-fov: ${vfovToHFov(this.camera.fov, this.camera.aspect)} v-fov: ${this.camera.fov}`)
        }
        this.needsUpdate()
    }

    get description() : string {
        return "Camera Intrinsics"
    }
}
